import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { EMPLOYEE_STATUS_OPTIONS } from "@/lib/employeeStatus";

interface EmployeeStatusSelectProps {
  value?: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function EmployeeStatusSelect({
  value,
  onChange,
  placeholder = "Select status",
  disabled = false,
  className,
}: EmployeeStatusSelectProps) {
  const normalizedValue =
    value && value.trim().length > 0 ? value : undefined;

  return (
    <Select
      disabled={disabled}
      value={normalizedValue}
      onValueChange={onChange}
    >
      <SelectTrigger className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {EMPLOYEE_STATUS_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
